import { useContext, useState } from "react"
import { FiAlertTriangle, FiX } from "react-icons/fi"

import { OrderContext } from "../../../context/OrderContext"
import { GlobalContext } from "../../../context/GlobalContext"
import { sendPrint } from "../../../reporting/print"
import { Toast } from "../../../utils/Toast"
import './style.css'

const refusalReasons = [
  'O cliente solicitou o cancelamento.',
  'Infelizmente não teremos estoque para atender o seu pedido.',
  'Desculpe, estamos passando por manutenções internas e não poderemos aceitar o seu pedido no momento.',
  'Por motivo de força maior, infelizmente não poderemos dar prosseguimento ao seu pedido. Pedimos desculpas pelo transtorno.',
  'Outro',
]

export function ModalRefusedOrder() {
  const { isAccess } = useContext(GlobalContext)
  const { refusedOrder, orderSelected } = useContext(OrderContext)
  const [motivation, setMotivation] = useState('')
  const [motivationMessage, setMotivationMessage] = useState('')

  function resetForm() {
    setMotivation('')
    setMotivationMessage('')
  }

  function onChange(value) {
    if (value !== 'Outro') setMotivationMessage('')
    setMotivation(value)
  }

  async function confirmation() {
    const message = motivation === 'Outro' ? motivationMessage.trim() : motivation

    if (!isAccess('pedidos', 'cancelar_pedido')) {
      return Toast.warning('Você não tem permissão para cancelar pedido')
    }

    if (!message || !orderSelected.id) {
      return Toast.warning('Favor selecionar um motivo.')
    }

    await sendPrint('cancel-order', {}, orderSelected.id)
    await refusedOrder(orderSelected.id, 'cancelado', message)
    resetForm()
    document.getElementById('close-with-modal-refused')?.click()
  }

  return (
    <div className="modal fade refused-order-modal" id="modalRefusedOrder" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalModalRefusedOrderLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header refused-order-header">
            <div className="refused-order-heading">
              <span><FiAlertTriangle size={19} /></span>
              <div>
                <h2 className="modal-title" id="modalModalRefusedOrderLabel">Cancelar pedido</h2>
                <p>Selecione o motivo do cancelamento</p>
              </div>
            </div>
            <button type="button" className="refused-order-close" data-bs-dismiss="modal" id="close-with-modal-refused" aria-label="Fechar" onClick={resetForm}><FiX size={21} /></button>
          </div>

          <div className="modal-body refused-order-body">
            <div className="refused-order-warning">
              <FiAlertTriangle size={17} />
              <span>Esta ação cancelará o pedido e não poderá ser desfeita.</span>
            </div>

            <fieldset className="refused-reasons">
              <legend>Motivo do cancelamento</legend>
              {refusalReasons.map((reason, index) => (
                <label className={`refused-reason ${motivation === reason ? 'selected' : ''}`} key={reason}>
                  <input type="radio" checked={motivation === reason} name="refusalReason" value={reason} onChange={() => onChange(reason)} />
                  <span className="refused-radio" />
                  <span>{reason}</span>
                </label>
              ))}
            </fieldset>

            {motivation === 'Outro' && (
              <div className="refused-custom-reason">
                <label htmlFor="customRefusalReason">Descreva o motivo</label>
                <textarea id="customRefusalReason" rows="3" value={motivationMessage} onChange={(event) => setMotivationMessage(event.target.value)} placeholder="Digite o motivo do cancelamento..." autoFocus />
              </div>
            )}
          </div>

          <div className="modal-footer refused-order-footer">
            <button type="button" className="refused-back-button" data-bs-dismiss="modal" onClick={resetForm}>Voltar</button>
            <button type="button" className="refused-confirm-button" disabled={!motivation || (motivation === 'Outro' && !motivationMessage.trim())} onClick={confirmation}>Confirmar cancelamento</button>
          </div>
        </div>
      </div>
    </div>
  )
}
